// generated by recipeyak.api.base.codegen
import { http } from "@/apiClient"

/**
 * Calls Django logout method and logs out current User object.
 *
 * Accepts/Returns nothing.
 */
export function userLogout() {
  return http<{
    detail: string
  }>({
    url: "/api/v1/auth/logout/",
    method: "post",
  })
}
